import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

export default function JsonCollapse({
  json,
  label = "info",
  defaulPlainText = false,
}) {
  const [open, setOpen] = useState(false);
  const [plainText, setPlainText] = useState(defaulPlainText);
  const { isLocal } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;

  if (!isLocal) {
    return <></>;
  }

  return !!json && typeof json === "object" ? (
    <>
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
      >
        <span className="fw-bold me-2">{label}:</span>
        {open ? (
          <FontAwesomeIcon icon={faCaretDown} />
        ) : (
          <FontAwesomeIcon icon={faCaretRight} />
        )}
      </button>

      {Array.isArray(json) ? "[" : "{"}

      {open && (
        <div className="bg-white p-2 rounded-2 ms-4 border overflow-auto">
          <button
            className="btn btn-link p-0 float-end"
            onClick={() => setPlainText(!plainText)}
          >
            {plainText ? "Show collapsible" : "Show plain"}
          </button>
          {plainText ? (
            <pre>{JSON.stringify(json, null, 2)}</pre>
          ) : (
            Object.entries(json).map(([key, value]) => (
              <div key={key} className="mb-2">
                <JsonCollapse json={value} label={key} />
              </div>
            ))
          )}
        </div>
      )}

      {Array.isArray(json) ? "]" : "}"}
    </>
  ) : (
    <span className="">
      <span className="fw-bold me-2">{label}:</span>
      {json === null ? "null" : json?.toString()}
    </span>
  );
}
